import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Market } from '../../shared/domain/Market'

export const DateRangeValidation = z.object({
  from: z.date(),
  to: z.date(),
})

export class DateRange extends Model {
  static create({ from, to }: { from: Date; to: Date }) {
    DateRangeValidation.parse({ from, to })
    return new DateRange(from, to)
  }

  static default() {
    return DateRange.fromMarket({ market: Market.default() })
  }

  static fromMarket({ market }: { market: Market }) {
    const from = new Date()
    const to = new Date()
    from.setDate(from.getDate() + market.inanitionDays())
    to.setDate(from.getDate() + market.defaultBookingDays())
    return new DateRange(from, to)
  }

  static fromAvailabilityApi({ from, to }: { from: string; to: string }) {
    return new DateRange(new Date(from), new Date(to))
  }

  constructor(
    private readonly _from: Date,
    private readonly _to: Date
  ) {
    super()
  }

  getNights() {
    return this._to.getDate() - this._from.getDate()
  }

  toJSON() {
    return {
      from: this._from,
      to: this._to,
    }
  }
}
